import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { Container } from 'ui/container'
import { List } from 'features/games/list'

import c from './assets/sass/page.module.scss'
import { PageTitle } from '../../features/common/page-title'

const GamesPage = () => {
    const { t } = useTranslation()
    const navigate = useNavigate()
    const handleFAQ = () => {
        navigate('/faq?category=modes')
    }

    return (
        <div className={c.component}>
            <PageTitle title={t('pages.games.title')} callback={handleFAQ} />
            <Container>
                <List />
            </Container>
        </div>
    )
}

export default GamesPage
